import { render, staticRenderFns } from "./PainelEmConstrucao.vue?vue&type=template&id=c7082500"
import script from "./PainelEmConstrucao.vue?vue&type=script&lang=js"
export * from "./PainelEmConstrucao.vue?vue&type=script&lang=js"
import style0 from "./PainelEmConstrucao.vue?vue&type=style&index=0&id=c7082500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports